import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';

import { PrivaButtonComponent } from '@priva/components/button';
import { PrivaCardComponent } from '@priva/components/card';
import { PrivaContentTemplateComponent } from '@priva/components/content-template';
import { PrivaGroupModule } from '@priva/components/group';
import { PrivaLocalizationModule } from '@priva/localization';

import { absoluteRoutePaths } from 'app/core/routing';
import { resetApiConfig } from 'app/state/api-config/api-config.actions';

@Component({
    selector: 'app-hard-reset',
    templateUrl: './hard-reset.component.html',
    styleUrl: './hard-reset.component.scss',
    imports: [
        PrivaButtonComponent,
        PrivaCardComponent,
        PrivaContentTemplateComponent,
        PrivaGroupModule,
        PrivaLocalizationModule,
    ],
})
export class HardResetComponent {
    private store = inject(Store);
    private router = inject(Router);

    async reset() {
        this.store.dispatch(resetApiConfig());
        await this.router.navigateByUrl(absoluteRoutePaths.setup, { replaceUrl: true });
    }

    async cancel() {
        await this.router.navigateByUrl(absoluteRoutePaths.settings, { replaceUrl: true });
    }
}
